import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../model';
import { map, tap } from 'rxjs/operators';
import { UserModel } from '../../model';
import { LocalStorage, LocalStorageService } from 'ngx-webstorage';
import { Router, ActivatedRoute } from '@angular/router';
import { throwError } from 'rxjs';

import { JwtHelperService } from "@auth0/angular-jwt";
import { AuthTokenService } from './auth-token.service';
import { Utils } from './../../../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  BASE_URL = environment.url;

  private user;
 // @LocalStorage('user')
  userDetails: UserModel;
  userRoles: any = [];

  constructor(
    private token: AuthTokenService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private storage: LocalStorageService
  ) { }




  jwt = new JwtHelperService();
  validToken;
  LOGIN_REDIRECT_URL = environment.loginUrl_SSO;
  LOGOUT_REDIRECT_URL = environment.logoutUrl_SSO;

  isAuthenticated() {

    if (this.token.getAccessToken) {
      return (
        this.token.getUser &&
        this.token.getAccessToken != null &&
        !this.isTokenExpired1(this.token.getAccessToken)
      );
    }
    return false;
  }
  isAuthenticated1() {
    if(localStorage.getItem('id_token')){
      return true
    }
    else 
      return false

    
    
  }
  isTokenExpired1(token: string): boolean {

    if (!token) return true;

  try {
    const decoded = this.jwt.decodeToken(token);
    const currentTime = Math.floor(new Date().getTime() / 1000);
    const eightHoursInSeconds = 8 * 60 * 60;
    
    // Check if the current time exceeds the token's expiry time by 8 hours
    return currentTime > (decoded.exp + eightHoursInSeconds);
  } catch (error) {
    console.error('Error decoding token', error);
    return true;
  }


  }

  public loginFromToken(tokenExternal1,tokenExternal2,tokenExternal3) {

    if (!tokenExternal1) { return false; }
    this.validToken = this.validateToken(tokenExternal1); // Check wether token is valid or not
    if (!this.validToken) return this.redirectToDaimler("login");

    if (this.clearLocalData()) {
      this.updateUserDetails(tokenExternal1,tokenExternal2,tokenExternal3);
      
    }
  }

  /* Update user information */
  updateUserDetails(tokenExternal1,tokenExternal2,tokenExternal3) {
    const decodedExternalToken = this.jwt.decodeToken(tokenExternal1);
    if (!decodedExternalToken) return;
    let userRolesFromToken = decodedExternalToken.roles;
    let userIdDynamic = 1;
    let uid=decodedExternalToken.Uid
    userRolesFromToken.forEach(role => {
      if(role.includes('eol_')) this.userRoles.push({"roleId": userIdDynamic++, "roleName": role});  
    });
   
    if(this.userRoles.length==0){
      Utils.alertWithErrorMessage("Token is expired or invalid. You will log off automatically");
      setTimeout(() => { this.logout(); }, 5000);
      return;
    }

    let username=uid.replace("@tbdir.net", "");
    this.userDetails = {
      shortId: username,
      employeeName: decodedExternalToken.given_name +" " +  decodedExternalToken.family_name, 
      firstName: '',
      lastName: '',
      accessPoint: 'web',
      emailId: decodedExternalToken.email,
      loginAttempts: '',
      phone: '',
      pictureUrl: '',
      status: 'Active',
      userRoles: this.userRoles,
      workLocation: '',
      userId: 1,
      employeeId: "1"
    };
    localStorage.setItem('access_token',tokenExternal2)
    localStorage.setItem('id_token',tokenExternal1)
    localStorage.setItem('refresh_token',tokenExternal3)
    // this.token.setIdToken = tokenExternal1
    // this.token.setRefreshToken = tokenExternal3;
    this.token.saveUser = this.userDetails;
    this.router.navigate(['/']);

  }
  public getRefreshtokenStorage() {

    let params = new HttpParams();
    params = params.append('code',localStorage.getItem('refresh_token'));
    params = params.append('isRefresh', 'true');
    params = params.delete('user_key');

    // params = params.append('shift', shiftType);
    // return this.http.get<ApiResponse<ProductionProgress>>(`${this.BASE_URL}/prodProgress`,{params: params})

    return this.http.get<any>(environment.refresh_token_url, { params }).pipe(
      tap((response) => {
        // Update tokens in local storage
        this.updateTokens(response);
      })
    );
  }
  updateTokens(tokens){
    localStorage.setItem('access_token', tokens.accessToken);
    localStorage.setItem('id_token', tokens.idToken);
    localStorage.setItem('refresh_token', tokens.refreshCode);


  }
  

  public validateToken(tokenExternal) {
    if (!this.jwt.isTokenExpired(tokenExternal)) return true;
    else return false;
  }

  private clearLocalData() {
    this.token.clearTokens();
    return true;
  }

  public logout() {
    this.redirectToDaimler("logout");
  }

  /* Redirect to Daimler SSO */
  public redirectToDaimler(status) {
    let redirectExternal = (status == "login") ? this.LOGIN_REDIRECT_URL : this.LOGOUT_REDIRECT_URL;
    this.clearLocalData();
    window.open(redirectExternal, "_self");
  }

  public changePassword(oldPassword: string, newPassword: string) {
    let credentials = {
      'shortId': this.userDetails.shortId,
      'oldPassword': oldPassword,
      'newPassword': newPassword
    }
    return this.http.post<ApiResponse<UserModel>>(`${this.BASE_URL}/user/change/password`, credentials)
      .pipe(
        map(data => {
          if (data.status.statusCode == 1) {
            this.userDetails = data.response;
            return data.status.statusMessage;
          } else {
            throw new Error(data.status.displayMessage)
          }
        })
      )

  }
}
